
// 上报来源枚举
const G_REPORT_SOURCE_MAP = {
    sdk: 1, // sdk上报
    business: 2 // 业务上报
}
// 前端事件枚举
const G_EVENT_CODE_MAP = {
    pageView: 'page_view', // 页面浏览
    pageStay: 'page_stay', // 页面停留时长
    pageOut: 'page_out', // 页面退出
    elementView: 'element_view', // 元素浏览
    elementClick: 'element_click', // 元素点击
    moduleView: 'module_view', // 模块曝光
    moduleClick: 'module_click' // 模块点击
}

const G_NET_TYPE_MAP = {
    'wifi': 'wifi',
    '4G': '4G',
    '5G': '5G'
}

const G_PAGE_TYPE_MAP = {
    'native': 'native',
    'flutter': 'flutter',
    'h5': 'h5',
    'weex': 'weex'
}
// 记录类型-同record_type
const G_APP_LOG_TYPE_MAP = {
    visit: 1, // 落访问表
    behavior: 2, // 落行为表
    monitor: 3 // 落监控表
}
//  行为类型 1：曝光；2：点击；3：截屏；
const G_EVENT_TYPE_MAP = {
    expose: 1, // 曝光
    click: 2, // 点击
    screen: 3 // 截屏
}
// 错误码
const G_ERROR_CODE_MAP = {
    '_pageReport': '10051',
    '_cacheCollect': '10052',
    '_cacheExec': '10053',
    '_domReportHandler': '10054',
    '_leaveReporter': '10055',
    '_pageStayReport': '10056',
    '_pageViewReport': '10057',
    '_init': '10058',
    'strategy': '10059'
}
export {
    G_REPORT_SOURCE_MAP,
    G_EVENT_CODE_MAP,
    G_NET_TYPE_MAP,
    G_PAGE_TYPE_MAP,
    G_APP_LOG_TYPE_MAP,
    G_EVENT_TYPE_MAP,
    G_ERROR_CODE_MAP
}